module.exports = __webpack_public_path__ + "img/stethoscope.6e3c1637.svg";